import React from 'react';
import { useNavigate } from 'react-router-dom';
import apiHooks from '../../../hooks/apiHooks';
import ListDataPage from '../../../components/pages/ListDataPage';
import dayjs from 'dayjs';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';

interface ActionItem {
  eventKey: string;
  label: string;
  type: 'function' | 'redirect'; // Ensure type is restricted
  callback?: () => void;
  url?: string;
  className?: string;
  divider?: boolean;
}

const AllSubscription = () => {
  const navigate = useNavigate(); // React Router hook for navigation

  // Function to return properly typed actions for each row
  const getActions = (
    sales_institute_id: string,
    subscription_id: string
  ): ActionItem[] => [
    {
      eventKey: '2',
      label: 'Edit',
      type: 'function',
      callback: () =>
        navigate(
          `/sales/subscription/edit-subscription/${subscription_id}/${sales_institute_id}`
        )
    },
    {
      eventKey: '3',
      label: 'Remove',
      type: 'function',
      // callback: () => deleteSalesService(service_id),
      className: 'text-danger'
    },
    // {
    //   eventKey: '3',
    //   label: 'Create Subscription',
    //   type: 'function',
    //   callback: () =>
    //     navigate(
    //       `/sales/subscription/create-subscription?institute_id=${sales_institute_id}`
    //     ),
    //   className: 'text-danger'
    // },
    {
      eventKey: '3',
      label: 'Create Order',
      type: 'function',
      callback: () =>
        navigate(
          `/sales/order/create-order?institute_id=${sales_institute_id}`
        ),
      className: 'text-danger'
    },
    {
      eventKey: '3',
      label: 'Record payment',
      type: 'function',
      callback: () =>
        navigate(
          `/sales/payments/add-payment?subscription_id=${subscription_id}`
        ),
      className: 'text-danger'
    }
  ];

  const columns = [
    { accessorKey: 'subscription_id', header: 'Subscription ID' },
    { accessorKey: 'sales_institute.institute_name', header: 'Institute Name' },
    {
      accessorKey: 'start_date',
      header: 'Start Date',
      cell: ({ row }: { row: any }) => (
        <span>{dayjs(row.original.start_date).format('DD/MM/YYYY')}</span>
      )
    },
    {
      accessorKey: 'end_date',
      header: 'End Date',
      cell: ({ row }: { row: any }) => (
        <span>{dayjs(row.original.end_date).format('DD/MM/YYYY')}</span>
      )
    },
    {
      id: 'expires_in',
      header: 'Expires In (Days)',
      cell: ({ row }: { row: any }) => {
        const today = dayjs();
        const endDate = dayjs(row.original.end_date);
        const diff = endDate.diff(today, 'day');
        return <span>{diff > 0 ? `${diff} days` : 'Expired'}</span>;
      }
    },
    { accessorKey: 'plan.plan_name', header: 'Plan' },
    { accessorKey: 'service.service_name', header: 'Service' },
    {
      accessorKey: 'created_at',
      header: 'Created At',
      cell: ({ row }: { row: any }) => (
        <span>
          {dayjs(row.original.created_at).format('DD/MM/YYYY HH:mm:ss')}
        </span>
      )
    },
    {
      id: 'action',
      header: 'Actions',
      cell: ({ row }: { row: any }) => (
        <RevealDropdownTrigger style={{ zIndex: '999' }}>
          <RevealDropdown>
            <ActionDropdownItems
              actions={getActions(
                row.original.sales_institute_id,
                row.original.subscription_id
              )}
            />
          </RevealDropdown>
        </RevealDropdownTrigger>
      ),
      meta: {
        headerProps: { style: { width: '7%' } },
        cellProps: { className: 'text-center' }
      }
    }
  ];

  return (
    <ListDataPage
      apiHook={apiHooks.useSalesSubscriptions}
      entityName="All Subscriptions"
      columns={columns}
    />
  );
};

export default AllSubscription;
